import { If } from '@cleartax/wg-library-conditionals';
import { DefaultFooter } from '../components/layout-components/footers/default-footer/index.component';
import { DefaultHeader } from '../components/layout-components/headers/default-header/index';

interface IDefaultLayout {
  meta: React.ReactNode;
  children: React.ReactNode;
  disableHeader?: boolean;
  disableFooter?: boolean;
}

const DefaultLayout = (props: IDefaultLayout) => {
  return (
    <>
      {props.meta}
      <If condition={!props.disableHeader}>
        <DefaultHeader />
      </If>
      <div className="antialiased w-full sm:flex-col sm:w-full sm:mx-0 sm:p-0">
        {props.children}
      </div>
      <If condition={!props.disableFooter}>
        <DefaultFooter />
      </If>
    </>
  );
};

export { DefaultLayout };
